import { render, staticRenderFns } from "./ressource-error.vue?vue&type=template&id=4b925f08&scoped=true&"
import script from "./ressource-error.vue?vue&type=script&lang=js&"
export * from "./ressource-error.vue?vue&type=script&lang=js&"
import style0 from "./ressource-error.vue?vue&type=style&index=0&id=4b925f08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b925f08",
  null
  
)

export default component.exports